<template>
  <w-settings-content-template>
    <div slot="content" style="width: 50%">
      <el-row class="title-bar"  type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h3 mr-r4">자동 승인</div>
          <el-switch v-model="autoApprovalInfo.AUTO.value" :active-value="1" :inactive-value="0" @change="changeTargetValue(arguments[0], ...'AUTO')">></el-switch>
        </div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="primary" :disabled="approvalSaveDisabled" @click="saveAutoFormData(['AUTO', 'LIMIT_CORE', 'LIMIT_MEMORY', 'LIMIT_DISK'])">저장</el-button>
          <el-button :disabled="approvalSaveDisabled" @click="loadAutoFormData(['AUTO', 'LIMIT_CORE', 'LIMIT_MEMORY', 'LIMIT_DISK'])">취소</el-button>
        </div>
      </el-row>
      <el-row class="mr-b30">
        <div class="list form-list">
          <el-form label-width="200px" label-position="left">
            <el-form-item label="CPU">
              <el-input v-model.number="autoApprovalInfo.LIMIT_CORE.value" type="number" style="width: calc(100% - 67px)"
              @keyup.native="changeTargetValue(arguments[0].target.value, ...'LIMIT_CORE')" @change="changeTargetValue(...arguments, ...'LIMIT_CORE')"></el-input>
              <span class="mr-l4">vCPU</span>
            </el-form-item>
            <el-form-item label="메모리">
              <el-input v-model.number="autoApprovalInfo.LIMIT_MEMORY.value" type="number" style="width: calc(100% - 67px)"
              @keyup.native="changeTargetValue(arguments[0].target.value, ...'LIMIT_MEMORY')" @change="changeTargetValue(...arguments, ...'LIMIT_MEMORY')"></el-input>
              <el-select v-model="autoApprovalInfo.LIMIT_MEMORY.unit" style="width: 62px" @change="changeTargetUnit(arguments, ...'LIMIT_MEMORY')">
                <el-option v-for="unit in unitInfo.LIMIT_MEMORY" :key="unit" :value="unit" :label="unit"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="디스크">
              <el-input v-model.number="autoApprovalInfo.LIMIT_DISK.value" type="number" style="width: calc(100% - 67px)"
              @keyup.native="changeTargetValue(arguments[0].target.value, ...'LIMIT_DISK')" @change="changeTargetValue(...arguments, ...'LIMIT_DISK')"></el-input>
              <el-select v-model="autoApprovalInfo.LIMIT_DISK.unit" style="width: 62px" @change="changeTargetUnit(arguments, ...'LIMIT_DISK')">
                <el-option v-for="unit in unitInfo.LIMIT_DISK" :key="unit" :value="unit" :label="unit"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-row>

      <div class="title-bar title-h3">승인 프로세스</div>
      <!-- 접수자 -->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4 mr-r4">접수자</div>
          <el-switch v-model="reception.activeFlag" active-value="Y" inactive-value="N" @change="onActiveSwitchChange(reception)"></el-switch>
        </div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="secondary" @click="openSettingPopup('접수자', reception)">편집</el-button>
          <el-button type="primary" :disabled="!reception.isModified" @click="saveProcessData(reception)">저장</el-button>
        </div>
      </el-row>
      <el-scrollbar class="bar-visible">
        <el-table-wrapper class="mr-b30" height="140px" :pagination="false" :column-default="columnDefault" :data="reception.mgrList" :columns="tableColumns"></el-table-wrapper>
      </el-scrollbar>
      <!-- 1차 승인자 -->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box title-h4 mr-r4">1차 승인자</div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="secondary" @click="openSettingPopup('1차 승인자', permissionFirst)">편집</el-button>
        </div>
      </el-row>
      <el-scrollbar class="bar-visible">
        <el-table-wrapper class="mr-b30" height="140px" :pagination="false" :column-default="columnDefault" :data="permissionFirst.mgrList" :columns="tableColumns"></el-table-wrapper>
      </el-scrollbar>
      <!-- 2차 승인자 -->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4 mr-r4">2차 승인자</div>
          <el-switch v-model="permissionSecond.activeFlag" active-value="Y" inactive-value="N" @change="onActiveSwitchChange(permissionSecond)"></el-switch>
        </div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="secondary" @click="openSettingPopup('2차 승인자', permissionSecond)">편집</el-button>
          <el-button type="primary" :disabled="!permissionSecond.isModified" @click="saveProcessData(permissionSecond)">저장</el-button>
        </div>
      </el-row>
      <el-scrollbar class="bar-visible">
        <el-table-wrapper class="mr-b30" height="140px" :pagination="false" :column-default="columnDefault" :data="permissionSecond.mgrList" :columns="tableColumns"></el-table-wrapper>
      </el-scrollbar>
      <!-- 확인자 -->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4 mr-r4">확인자</div>
          <el-switch v-model="confirmorConfirm.activeFlag" active-value="Y" inactive-value="N" @change="onActiveSwitchChange(confirmorConfirm)"></el-switch>
        </div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="secondary" @click="openSettingPopup('확인자', confirmorConfirm)">편집</el-button>
          <el-button type="primary" :disabled="!confirmorConfirm.isModified" @click="saveProcessData(confirmorConfirm)">저장</el-button>
        </div>
      </el-row>
      <el-scrollbar class="bar-visible">
        <el-table-wrapper class="mr-b30" height="140px" :pagination="false" :column-default="columnDefault" :data="confirmorConfirm.mgrList" :columns="tableColumns"></el-table-wrapper>
      </el-scrollbar>

      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box title-h3 mr-r4">프로세스 완료 후 자동 종료일</div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="primary" :disabled="finishDateSaveDisabled" @click="saveAutoFormData(['AUTO_REQUEST_FINISH_DATE'])">저장</el-button>
          <el-button :disabled="finishDateSaveDisabled" @click="loadAutoFormData(['AUTO_REQUEST_FINISH_DATE'])">취소</el-button>
        </div>
      </el-row>
      <div class="list form-list">
        <el-form label-width="200px" label-position="left">
          <el-form-item label="자동 종료일">
            <el-input v-model.number="autoApprovalInfo.AUTO_REQUEST_FINISH_DATE.value" type="number" style="width: calc(100% - 19px)"
            @keyup.native="changeTargetValue(arguments[0].target.value, ...'AUTO_REQUEST_FINISH_DATE')" @change="changeTargetValue(...arguments, ...'AUTO_REQUEST_FINISH_DATE')"></el-input>
            <span class="mr-l4">일</span>
          </el-form-item>
        </el-form>
      </div>
      <w-request-target-setting-popup :popup-params="popupParams" @reload="reloadProcessData" ref="requestTargetSettingPopup"></w-request-target-setting-popup>
    </div>
  </w-settings-content-template>
</template>

<script>
import { camelCase, cloneDeep, isEqual, isNil, mapKeys } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import basicinfoSetAPI from '@/api/model/basicinfo-set';
import provisioningSettingsAPI from '@/api/settings/virtual/provisioning-settings';
import msgUtil from '@/utils/message';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WRequestTargetSettingPopup from './popup/RequestTargetSettingPopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WRequestProcess',
  components: {
    WSettingsContentTemplate,
    WRequestTargetSettingPopup,
  },
  data() {
    return {
      unitInfo: {
        LIMIT_MEMORY: ['GB', 'MB'],
        LIMIT_DISK: ['GB', 'MB', 'TB'],
      },
      columnDefault,
      popupParams: {},
      autoApprovalInfo: {
        AUTO: {},
        LIMIT_CORE: {},
        LIMIT_DISK: {},
        LIMIT_MEMORY: {},
        AUTO_REQUEST_FINISH_DATE: {},
      },
      originAutoApprovalInfo: {},
      reception: {
        activeFlag: 'N',
        mgrList: [],
      },
      permissionFirst: {
        activeFlag: 'Y',
        mgrList: [],
      },
      permissionSecond: {
        activeFlag: 'N',
        mgrList: [],
      },
      confirmorConfirm: {
        activeFlag: 'N',
        mgrList: [],
      },
      tableColumns: [
        { label: '이름', prop: 'managerName', formatter: defaultFormatter },
        { label: '아이디', prop: 'managerId' },
        { label: '모바일', prop: 'mobileNumber', formatter: defaultFormatter },
        { label: '이메일', prop: 'email', formatter: defaultFormatter },
      ],
    };
  },
  computed: {
    approvalSaveDisabled() {
      const auto = this.autoApprovalInfo.AUTO;
      const limitCore = this.autoApprovalInfo.LIMIT_CORE;
      const limitDisk = this.autoApprovalInfo.LIMIT_DISK;
      const limitMemory = this.autoApprovalInfo.LIMIT_MEMORY;
      return !(auto.isModified || limitCore.isModified || limitDisk.isModified || limitMemory.isModified);
    },
    finishDateSaveDisabled() {
      const finishDate = this.autoApprovalInfo.AUTO_REQUEST_FINISH_DATE;
      return !(finishDate.isModified);
    },
  },
  mounted() {
    this.loadAutoFormData();
    this.loadProcessData();
  },
  methods: {
    /**
     * 프로비저닝 요청 프로세스 > 승인 프로세스 데이터 로드
     * @author jeee12
     * @param  {[type]} taskId 조회할 특정 taskId
     * @return {[type]}        [description]
     */
    loadProcessData(taskId) {
      const params = {};
      if (!isNil(taskId)) {
        params.taskId = taskId;
      }
      provisioningSettingsAPI.getVmsReqTaskList(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          let targetKey;
          result.forEach((reqTask) => {
            targetKey = reqTask.taskId;
            this[`${camelCase(targetKey)}`] = { isModified: false, ...cloneDeep(reqTask) };
          });
        }
      });
    },
    /**
     * 프로비저닝 요청 프로세스 > 자동 승인 / 자동 종료일 설정 form 데이터 로드
     * @author jeee12
     * @param  {[type]} basicinfoSubids basicinfoSubid 배열
     * @return {[type]}             [description]
     */
    loadAutoFormData(basicinfoSubids) {
      basicinfoSetAPI.getList('VMPROVISIONING').then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.setAutoApprovalInfo(result, basicinfoSubids);
        }
      });
    },
    /**
     * 자동 승인, 자동 종료일 data 설정 (autoApprovalInfo, originAutoApprovalInfo)
     * @author jeee12
     * @param  {[type]} autoApprovalInfos  데이터 조회 결과 list
     * @param  {[type]} basicinfoSubids 가공할 basicinfoSubids
     */
    setAutoApprovalInfo(autoApprovalInfos, basicinfoSubids) {
      if (!isNil(basicinfoSubids)) { // 가공할 basicinfoSubids가 있는 경우
        basicinfoSubids.forEach((basicinfoSubid) => {
          const matchedInfo = autoApprovalInfos.find((data) => data.basicinfoSubid === basicinfoSubid);
          const datatypeId = matchedInfo.datatypeId === 'BOOL' ? 'BOOLEAN' : matchedInfo.datatypeId;
          this.autoApprovalInfo[matchedInfo.basicinfoSubid] = {
            value: matchedInfo[camelCase(`basicinfoSubvalue${datatypeId}`)],
            unit: matchedInfo.basicinfoSubunit,
            datatypeId,
            isModified: false,
          };
        });
      } else {
        autoApprovalInfos.forEach((data) => {
          const datatypeId = data.datatypeId === 'BOOL' ? 'BOOLEAN' : data.datatypeId;
          this.autoApprovalInfo[data.basicinfoSubid] = {
            value: data[camelCase(`basicinfoSubvalue${datatypeId}`)],
            unit: data.basicinfoSubunit,
            datatypeId,
            isModified: false,
          };
        });
      }
      this.originAutoApprovalInfo = cloneDeep(this.autoApprovalInfo);
    },
    /**
     * 자동 승인, 자동종료일 form 저장 버튼 클릭
     * @author jeee12
     * @param  {[type]} basicinfoSubids 저장할 basicinfoSubids
     */
    saveAutoFormData(basicinfoSubids) {
      const target = '정보';
      const action = msgUtil.action.SAVE;
      const params = [];
      mapKeys(this.autoApprovalInfo, (value, key) => {
        const basicinfoSubid = key;
        const isMatched = basicinfoSubids.indexOf(basicinfoSubid) > -1;
        if (isMatched && value.isModified) {
          const subValueKey = camelCase(`basicinfoSubvalue${value.datatypeId}`);
          const subValue = value.datatypeId === 'INTEGER' ? Number(value.value) : value.value;
          params.push({
            basicinfoId: 'VMPROVISIONING',
            basicinfoSubid,
            basicinfoSubunit: value.unit,
            [subValueKey]: subValue,
          });
        }
      });
      basicinfoSetAPI.updateList(params).then((response) => {
        if (response.data.success) {
          this.loadAutoFormData(basicinfoSubids);
        }
        this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    /**
     * 승인 프로세스 활성화 여부 저장
     * @author jeee12
     * @param  {[type]} reqTask 저장할 task 정보
     */
    saveProcessData(reqTask) {
      const target = '정보';
      const action = msgUtil.action.SAVE;
      if (!isNil(reqTask.isModified)) {
        delete reqTask.isModified;
      }
      provisioningSettingsAPI.updateVmsReqTaskList(reqTask).then((response) => {
        if (response.data.success) {
          this.loadProcessData(reqTask.taskId);
        }
        this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    /**
     * 대상값에 대한 수정여부 체크
     * @author jeee12
     * @param  {[type]} basicinfoSubid 대상 값의 key
     * @return {[type]}              [description]
     */
    changeTargetValue(value, basicinfoSubid) {
      if (!isNaN(value)) { // 숫자만 허용
        const changedInfo = this.autoApprovalInfo[basicinfoSubid];
        const originInfo = this.originAutoApprovalInfo[basicinfoSubid];
        this.autoApprovalInfo[basicinfoSubid].isModified = !isEqual(changedInfo.value, originInfo.value);
      }
    },
    /**
     * 대상 단위에 대한 수정여부 체크
     * @author jeee12
     * @param  {[type]} basicinfoSubid 대상 값의 key
     * @return {[type]}              [description]
     */
    changeTargetUnit(unit, basicinfoSubid) {
      const changedInfo = this.autoApprovalInfo[basicinfoSubid];
      const originInfo = this.originAutoApprovalInfo[basicinfoSubid];
      this.autoApprovalInfo[basicinfoSubid].isModified = !isEqual(changedInfo.unit, originInfo.unit);
    },
    /**
     * 승인 프로세스 switch change
     * @author jeee12
     * @param  {[type]} reqTask [description]
     */
    onActiveSwitchChange(reqTask) {
      reqTask.isModified = !reqTask.isModified;
    },
    /**
     * 승인 프로세스 관리자 설정 팝업 open
     * @author jeee12
     * @param  {[type]} targetName  [description]
     * @param  {[type]} reqTaskInfo [description]
     */
    openSettingPopup(targetName, reqTaskInfo) {
      this.popupParams = {
        taskId: reqTaskInfo.taskId,
        targetList: reqTaskInfo.mgrList,
        targetName,
      };
      this.$refs.requestTargetSettingPopup.open();
    },
    /**
     * 승인 프로세스 목록 reload
     * @author jeee12
     * @param  {[type]} taskId 특정 taskId
     */
    reloadProcessData(taskId) {
      this.loadProcessData(taskId);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/Provisioning/RequestProcess/index.vue